/* RESPONSIBLE TEAM: team-proactive-support */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-bare-strings */
import BaseValidator from 'ember-cp-validations/validators/base';
import moment from 'moment-timezone';
import { isEmpty } from '@ember/utils';

const RulesetHasValidScheduledActivation = BaseValidator.extend({
  validate(value, options, model) {
    if (isEmpty(model.scheduledActivation)) {
      return true;
    }

    let currentDate = moment();
    let scheduledActivationDate = moment(model.scheduledActivation.changeAt);

    if (scheduledActivationDate <= currentDate) {
      return 'Choose a valid start date';
    }

    return true;
  },
});

RulesetHasValidScheduledActivation.reopenClass({
  getDependentsFor() {
    return ['model.scheduledActivation', 'model.scheduledActivation.changeAt'];
  },
});

export default RulesetHasValidScheduledActivation;
